<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>
            <v-icon>mdi-clipboard-text</v-icon>Locations
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn text @click="formOpen = true">
              <v-icon>mdi-plus</v-icon>Add Locations
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-data-table
          :headers="headers"
          :items="locations"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalCount"
          :expanded.sync="expanded"
          :single-expand="true"
          show-expand
        >
          <template v-slot:item.actions="{item}">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-4">
              <shippings-list :locationId="item.id"></shippings-list>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <list-form
        :item="editedItem"
        :open="formOpen"
        v-on:add="addItem()"
        v-on:cancel="cancelItem()"
        v-on:update="updateItem()"
      ></list-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ListForm from "./_form";
import ShippingsList from "@/components/shipping/ShippingsList.vue";
import _ from "lodash";
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    ListForm,
    ShippingsList
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Name", value: "name", align: "left" },
        { text: "Country", value: "country", align: "left" },
        { text: "Actions", value: "actions", align: "right" }
      ],
      options: { rowsPerPage: 10 },
      formOpen: false,
      editedItem: null,
      expanded:[],
    };
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        this.getLocations();
      }, 100)
    },
    search: {
      handler: _.debounce(function() {
        this.getLocations();
      }, 100)
    }
  },
  computed: {
    ...mapGetters('locations',["locations","loading","totalCount"])
  },
  mounted: function() {
    this.getLocations(); //method1 will execute at pageload
  },
  methods: {
    ...mapActions('locations',{list: 'list', index: 'index'}),
    getLocations() {
      this.index({
        pagination: this.options
      });
      // console.log("get Location")
    },
    addItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.getLocations();
    },
    updateItem() {
      console.log("fini Update")
      this.formOpen = false;
      this.editedItem = null;
      this.getLocations();
    },
    cancelItem() {
      this.formOpen = false;
      this.editedItem = null;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.formOpen = true;
    },
    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.$store
          .dispatch("locations/delete", {
            model: item
          })
          .then(() => {
            this.getLocations();
            this.flashMessage.success({
              message: 'Location deleted succesfully',
            })
          })
          .catch(({data}) => {
            console.log("data",data);
            this.flashMessage.error({
              message: 'Error: Location used somewhere else',
            })
          });
    }
  }
};
</script>
